<template>
  <section class="page-section">
    <el-tabs v-model="tabName" type="card" @tab-click="handleTabsChange">
      <el-tab-pane label="服务推荐" name="0"></el-tab-pane>
      <el-tab-pane label="服务分类" name="1"></el-tab-pane>
      <el-tab-pane label="商品分类" name="2"></el-tab-pane>
    </el-tabs>

    <el-button
      type="primary"
      class="btn-add-block"
      @click="pageNavigateToShopComponentIndexAdd('')"
      v-if="tabName == 0"
      >新建服务推荐</el-button
    >
    <el-button
      type="primary"
      class="btn-add-block"
      @click="pageNavigateToShopComponentCategoryAdd()"
      v-if="tabName == 1"
      >新建服务分类</el-button
    >
    <el-button
      type="primary"
      class="btn-add-block"
      @click="pageNavigateToShopComponentCategoryAdd()"
      v-if="tabName == 2"
      >新建商品分类</el-button
    >

    <!-- table -->
    <div class="table-region" v-loading="tableLoading" v-if="tabName == 0">
      <!-- 首页组件 -->
      <el-table size="small" :data="tableData" v-if="tabName == 0">
        <el-table-column label="图标" width="200">
          <template slot-scope="scope">
            <div class="thumb-wrap">
              <img :src="scope.row.pic" style="pointer-events: none" />
            </div>
          </template>
        </el-table-column>
        <el-table-column label="关键词">
          <template slot-scope="scope">
            <p>{{ scope.row.keyword }}</p>
          </template>
        </el-table-column>
        <el-table-column label="标题">
          <template slot-scope="scope">
            <p>{{ scope.row.title }}</p>
          </template>
        </el-table-column>
        <el-table-column label="关联">
          <template slot-scope="scope">
            <p>{{ getRedirectTypeStr(scope.row.redirectType) || "-" }}</p>
          </template>
        </el-table-column>
        <el-table-column label="数量">
          <template slot-scope="scope">
            <p>{{ scope.row.relations || "-" }}</p>
          </template>
        </el-table-column>
        <el-table-column label="最后编辑时间">
          <template slot-scope="scope">
            <p>{{ COMMON.formatDate("2", "-", scope.row.lastUpdateDate) }}</p>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="right">
          <template slot-scope="scope">
            <el-button
              size="small"
              type="text"
              @click="pageNavigateToShopComponentIndexAdd(scope.row.id)"
              >编辑</el-button
            >

            <template v-if="tableData.length > 4">
              <el-popover
                placement="left"
                width="160"
                v-model="scope.row.deleteVisible"
                popper-class="confirm-popover"
              >
                <p>确定删除？</p>
                <div>
                  <el-button
                    size="small"
                    type="default"
                    plain
                    @click="scope.row.deleteVisible = false"
                    >取消</el-button
                  >
                  <el-button
                    size="small"
                    type="primary"
                    :loading="operateLoading"
                    @click="handleShopComponentIndexDelete(scope.row)"
                    >确定</el-button
                  >
                </div>

                <el-button size="small" type="text" slot="reference"
                  >删除</el-button
                >
              </el-popover>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 类目自定义表格 -->
    <div
      class="custom-table margin-top-20"
      v-loading="tableLoading"
      v-if="tabName == 1 || tabName == 2"
    >
      <div class="custom-table-body">
        <div class="no-data border" v-if="tableData.length == 0">暂无数据</div>

        <div v-else>
          <!-- item -->
          <div
            class="order-list-item no-margin-top-no-border"
            v-for="(item, index) in tableData"
            :key="index"
          >
            <div class="item-header">
              <div class="flex-h express-title">
                <div class="text lh48 flex-a-i express-item">
                  一级类目：{{ item.name }}
                </div>
                <div class="express-info express-item">
                  <span class="text lh48 tips-color"
                    >最后编辑时间：{{ item.time }}</span
                  >
                  <span class="text lh48 ml20"
                    ><el-button
                      size="small"
                      type="text"
                      @click="pageNavigateToShopComponentCategoryAdd(item.id)"
                      >修改</el-button
                    ></span
                  >

                  <el-popover
                    placement="left"
                    width="160"
                    v-model="item.deleteVisible"
                    popper-class="confirm-popover"
                    v-if="item.canDelete"
                  >
                    <p>确定删除？</p>
                    <div>
                      <el-button
                        size="small"
                        type="default"
                        plain
                        @click="item.deleteVisible = false"
                        >取消</el-button
                      >
                      <el-button
                        size="small"
                        type="primary"
                        :loading="operateLoading"
                        @click="handleDelete(item)"
                        >确定</el-button
                      >
                    </div>

                    <span class="text lh48 ml20" slot="reference"
                      ><el-button size="small" type="text"
                        >删除</el-button
                      ></span
                    >
                  </el-popover>

                  <span
                    class="text lh48 ml10 cursor-hand"
                    @click="handleShowCategoryDetail(index)"
                    ><i v-if="item.upVisible" class="el-icon-arrow-down"></i
                    ><i v-else class="el-icon-arrow-up"></i
                  ></span>
                </div>
              </div>
            </div>
            <el-collapse-transition>
              <div v-if="!item.upVisible">
                <div class="item-body">
                  <el-row :gutter="10">
                    <template v-if="tabName == 1">
                      <el-col :span="6">
                        <div class="table-cell">
                          <p class="text lh28">二级类目</p>
                        </div>
                      </el-col>
                      <el-col :span="6">
                        <div class="table-cell">
                          <p class="text lh28">关联项目数</p>
                        </div>
                      </el-col>
                      <el-col :span="6">
                        <div class="table-cell">
                          <p class="text lh28">状态</p>
                        </div>
                      </el-col>
                      <el-col :span="6">
                        <div class="table-cell">
                          <p class="text lh28">操作</p>
                        </div>
                      </el-col>
                    </template>
                    <template v-if="tabName == 2">
                      <el-col :span="6">
                        <div class="table-cell">
                          <p class="text lh28">二级类目</p>
                        </div>
                      </el-col>
                      <el-col :span="6">
                        <div class="table-cell">
                          <p class="text lh28">关联商品数</p>
                        </div>
                      </el-col>
                      <el-col :span="6">
                        <div class="table-cell">
                          <p class="text lh28">状态</p>
                        </div>
                      </el-col>
                      <el-col :span="6">
                        <div class="table-cell">
                          <p class="text lh28">操作</p>
                        </div>
                      </el-col>
                    </template>
                  </el-row>
                </div>
                <div
                  class="item-body"
                  v-for="(subItem, subIndex) in item.secondCategoryListVos"
                  :key="subIndex"
                >
                  <el-row :gutter="10">
                    <template v-if="tabName == 1">
                      <el-col :span="6">
                        <div class="table-cell">
                          <p class="text lh28">{{ subItem.name }}</p>
                        </div>
                      </el-col>
                      <el-col :span="6">
                        <div class="table-cell">
                          <p class="text lh28">{{ subItem.commodityNum }}</p>
                        </div>
                      </el-col>
                      <el-col :span="6">
                        <div class="table-cell">
                          <p class="text lh28" v-if="subItem.status == 0">
                            已下线
                          </p>
                          <p class="text lh28" v-if="subItem.status == 1">
                            已上线
                          </p>
                        </div>
                      </el-col>
                    </template>
                    <template v-if="tabName == 2">
                      <el-col :span="6">
                        <div class="table-cell">
                          <p class="text lh28">{{ subItem.name }}</p>
                        </div>
                      </el-col>
                      <el-col :span="6">
                        <div class="table-cell">
                          <p class="text lh28">{{ subItem.commodityNum }}</p>
                        </div>
                      </el-col>
                      <el-col :span="6">
                        <div class="table-cell">
                          <p class="text lh28" v-if="subItem.status == 0">
                            已下线
                          </p>
                          <p class="text lh28" v-if="subItem.status == 1">
                            已上线
                          </p>
                        </div>
                      </el-col>
                    </template>
                    <el-col :span="6">
                      <div class="table-cell">
                        <el-popover
                          placement="left"
                          width="160"
                          v-model="subItem.operateVisible"
                          popper-class="confirm-popover"
                        >
                          <p v-if="subItem.status == 0">确定上线？</p>
                          <p v-if="subItem.status == 1">确定下线？</p>
                          <div>
                            <el-button
                              size="small"
                              type="default"
                              plain
                              @click="subItem.operateVisible = false"
                              >取消</el-button
                            >
                            <el-button
                              size="small"
                              type="primary"
                              :loading="operateLoading"
                              @click="handleCategoryUpDown(subItem)"
                              >确定</el-button
                            >
                          </div>

                          <span class="text lh48 ml20" slot="reference">
                            <el-button
                              size="small"
                              type="text"
                              v-if="subItem.status == 0"
                              >上线</el-button
                            >
                            <el-button
                              size="small"
                              type="text"
                              v-if="subItem.status == 1"
                              >下线</el-button
                            >
                          </span>
                        </el-popover>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-collapse-transition>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  COMMON,
  shopComponentServiceSort,
  moduleCategoryList,
  moduleCategoryUpdateStatus,
  moduleCategorySort,
} from "@/common/api";
import {
  shopComponentServiceRecommendList,
  shopComponentServiceDelete,
} from "@/common/api";

export default {
  name: "shopComponentList",
  data() {
    return {
      COMMON,

      tabName: this.$route.query.name ? "" + this.$route.query.name : "0", //选项卡name

      tableLoading: true,
      tableData: [], //表格数据
      operateLoading: false,

      redirectTypeOptions: [
        {
          label: "服务",
          value: 1,
        },
        {
          label: "服务分类",
          value: 2,
        },
        {
          label: "商品",
          value: 3,
        },
        {
          label: "商品分类",
          value: 4,
        },
        {
          label: "详情页",
          value: 5,
        },
      ],
    };
  },
  watch: {
    /**
     * [description] 监听表单数据变化
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    tableData: function (val) {
      // 等渲染完后绑定事件
      this.$nextTick(function () {
        this.handleTableRowSort();
      });
    },
  },
  computed: {
    getRedirectTypeStr(type) {
      return function (type) {
        const item = this.redirectTypeOptions.filter(
          (row) => row.value == type,
        );
        return item[0] ? item[0].label : "";
      };
    },
  },
  methods: {
    /**
     * [handleTabsChange description] 切换选项卡
     * @param  {[type]} tab   [description] 取name值用tab.name
     * @param  {[type]} event [description]
     * @return {[type]}       [description]
     */
    handleTabsChange: function (tab, event) {
      this.$router.push({
        path: "/shop/component/list",
        query: { name: tab.name },
      });
      this.tableData = [];
      this.getList();
    },
    /**
     * [getList description] 获取表格数据
     * @return {[type]} [description]
     */
    getList: function () {
      if (this.tabName == 0) {
        this.getRecommendList();
      } else if (this.tabName == 1 || this.tabName == 2) {
        this.getCategoryList();
      }
    },
    /**
     * [getRecommendList description] 服务推荐管理
     * @return {[type]} [description]
     */
    getRecommendList() {
      this.tableLoading = true;

      let params = {};

      shopComponentServiceRecommendList(params)
        .then((res) => {
          this.tableLoading = false;

          let { code, data, msg } = res;

          if (code == 0) {
            let dataArray = data || [];

            this.tableData = dataArray;
          } else {
            this.$message.error(msg);
          }
        })
        .catch((error) => {
          this.$message.error("服务器异常");
        });
    },
    /**
     * [getCategoryList description] 类目 - 列表
     * @return {[type]} [description]
     */
    getCategoryList: function () {
      this.tableLoading = true;

      let params = {
        catType: this.tabName == 1 ? 2 : 1,
        current: 1,
        size: 10000,
      };

      moduleCategoryList(params)
        .then((res) => {
          this.tableLoading = false;

          let { code, data, msg } = res;

          if (code == 0) {
            let dataArray = data.records || [];

            if (dataArray.length > 0) {
              for (let i = 0; i < dataArray.length; i++) {
                dataArray[i].upVisible = true;
              }
            }

            this.tableData = dataArray;
          } else {
            this.$message.error(msg);
          }
        })
        .catch((error) => {
          this.$message.error("服务器异常");
        });
    },
    /**
     * [handleShowCategoryDetail description] 类目 - 展开
     * @param  {[type]} index [description]
     * @return {[type]}       [description]
     */
    handleShowCategoryDetail: function (index) {
      this.tableData[index].upVisible = !this.tableData[index].upVisible;
    },
    /**
     * [handleDelete description] 类目 - 删除一级类目
     * @return {[type]} [description]
     */
    handleDelete: function (item) {
      this.handleCategoryUpdateStatus(item.id, 1, -1);
    },
    /**
     * [handleCategoryUpDown description] 类目 - 二级类目上下架
     * @param  {[type]} index    [description]
     * @param  {[type]} subIndex [description]
     * @return {[type]}          [description]
     */
    handleCategoryUpDown: function (item) {
      let status = "";
      if (item.status == 0) {
        status = 1;
      } else if (item.status == 1) {
        status = 0;
      }
      this.handleCategoryUpdateStatus(item.id, 2, status);
    },
    /**
     * [handleCategoryUpdateStatus description] 类目 - 更新类目状态
     * @return {[type]} [description]
     */
    handleCategoryUpdateStatus: function (id, type, status) {
      this.operateLoading = true;

      let params = {
        catType: this.tabName == 1 ? 2 : 1,
        id: id,
        type: type,
        status: status,
      };

      moduleCategoryUpdateStatus(params)
        .then((res) => {
          this.operateLoading = false;

          let { code, data, msg } = res;

          if (code == 0) {
            this.getCategoryList();
          } else {
            this.$message.error(msg);
          }
        })
        .catch((error) => {
          this.operateLoading = false;
          this.$message.error("服务器异常");
        });
    },
    /**
     * [handleTableRowSort description] 给表格每一行绑定移动事件
     * @return {[type]} [description]
     */
    handleTableRowSort: function () {
      let tableTR = "";
      if (this.tabName == 1 || this.tabName == 2) {
        tableTR = document
          .getElementsByClassName("custom-table-body")[0]
          .getElementsByClassName("order-list-item");
      } else {
        tableTR = document
          .getElementsByClassName("el-table__body")[0]
          .getElementsByTagName("tr");
      }

      for (let i = 0; i < tableTR.length; i++) {
        let tableTRItem = "";
        if (this.tabName == 1 || this.tabName == 2) {
          tableTRItem = tableTR[i].getElementsByClassName("item-header")[0];
        } else {
          tableTRItem = tableTR[i];
        }

        tableTRItem.draggable = true;
        tableTRItem.setAttribute("data-index", i);
        tableTRItem.setAttribute("data-id", this.tableData[i].id);
        tableTRItem.setAttribute("data-order", this.tableData[i].sequence);
        tableTRItem.style.cursor = "all-scroll";

        tableTRItem.removeEventListener(
          "dragstart",
          this.handleTableTRDragStart,
        );
        tableTRItem.addEventListener(
          "dragstart",
          this.handleTableTRDragStart,
          false,
        );

        tableTRItem.removeEventListener("dragover", this.handleTableTRDragover);
        tableTRItem.addEventListener(
          "dragover",
          this.handleTableTRDragover,
          false,
        );

        tableTRItem.removeEventListener("drop", this.handleTableTRDrop);
        tableTRItem.addEventListener("drop", this.handleTableTRDrop, false);
      }
    },
    /**
     * [handleTableTRDragStart description] 拖动开始，设置携带的参数
     * @param  {[type]} ev [description] 拖动对象
     * @return {[type]}    [description]
     */
    handleTableTRDragStart: function (ev) {
      ev.dataTransfer.setData("index", ev.target.dataset.index);
      ev.dataTransfer.setData("id", ev.target.dataset.id);
      ev.dataTransfer.setData("order", ev.target.dataset.order);
    },
    /**
     * [handleTableTRDragover description] 必须要 preventDefault, 否则不会触发 drop
     * @param  {[type]} ev [description]
     * @return {[type]}    [description]
     */
    handleTableTRDragover: function (ev) {
      ev.preventDefault();
    },
    /**
     * [handleTableTRDrop description] 拖动释放触发的方法
     * @param  {[type]} ev [description] 目标对象
     * @return {[type]}    [description]
     */
    handleTableTRDrop: function (ev) {
      ev.preventDefault();

      let originalIndex = ev.dataTransfer.getData("index"),
        originalId = ev.dataTransfer.getData("id"),
        originalOrder = ev.dataTransfer.getData("order"),
        trNode = "";

      if (this.tabName == 1 || this.tabName == 2) {
        trNode = this.handleGetItemHeaderNode(ev.target);
      } else {
        trNode = this.handleGetTRNode(ev.target);
      }

      let targetIndex = trNode.getAttribute("data-index"),
        targetOrder = trNode.getAttribute("data-order");

      if (originalIndex == targetIndex) {
        // 原地释放
        return false;
      }

      // 将移动的对象插入目标对象之前
      let originalObject = this.tableData.splice(originalIndex, 1);
      this.tableData.splice(targetIndex, 0, originalObject[0]);

      // do request
      this.tableLoading = true;

      let params = {
        catType: this.tabName == 1 ? 2 : 1,
        sourceId: originalId,
        sourceOrder: originalOrder,
        targetOrder: targetOrder,
      };
      if (this.tabName == 0) {
        shopComponentServiceSort(params)
          .then((res) => {
            this.tableLoading = false;

            let { code, data, msg } = res;

            if (code == 0) {
              this.$message({ message: "移动成功", type: "success" });
              this.getList();
            } else {
              this.$message.error(msg);
              this.getList();
            }
          })
          .catch((error) => {
            this.tableLoading = false;
            this.$message.error("服务器异常");
          });
      } else if (this.tabName == 1 || this.tabName == 2) {
        moduleCategorySort(params)
          .then((res) => {
            this.tableLoading = false;

            let { code, data, msg } = res;

            if (code == 0) {
              this.$message({ message: "移动成功", type: "success" });
              this.getList();
            } else {
              this.$message.error(msg);
              this.getList();
            }
          })
          .catch((error) => {
            this.tableLoading = false;
            this.$message.error("服务器异常");
          });
      }
    },
    /**
     * [handleGetTRNode description] 循环查找dom父节点，直到匹配到tr
     * @param  {[type]} ob [description] 当前dom节点
     * @return {[type]}    [description]
     */
    handleGetTRNode: function (ob) {
      if (ob.tagName == "TR") {
        return ob;
      } else {
        return this.handleGetTRNode(ob.parentNode);
      }
    },
    /**
     * [handleGetItemHeaderNode description] 循环查找dom父节点，直到匹配到.item-header
     * @param  {[type]} ob [description] 当前dom节点
     * @return {[type]}    [description]
     */
    handleGetItemHeaderNode: function (ob) {
      if (ob.className == "item-header") {
        return ob;
      } else {
        return this.handleGetItemHeaderNode(ob.parentNode);
      }
    },
    /**
     * [pageNavigateToShopComponentIndexAdd description] 类目 - 跳转到编辑页
     * @return {[type]} [description]
     */
    pageNavigateToShopComponentIndexAdd: function (id) {
      if (id) {
        this.$router.push({ path: "/shop/component/index", query: { id: id } });
      } else {
        this.$router.push({ path: "/shop/component/index" });
      }
    },
    /**
     * [pageNavigateToShopComponentCategoryAdd description] 类目 - 跳转到编辑页
     * @return {[type]} [description]
     */
    pageNavigateToShopComponentCategoryAdd: function (id) {
      if (this.tabName == 1) {
        if (id) {
          this.$router.push({
            path: "/shop/component/category",
            query: { id: id, catType: 2 },
          });
        } else {
          this.$router.push({
            path: "/shop/component/category",
            query: { catType: 2 },
          });
        }
      } else if (this.tabName == 2) {
        if (id) {
          this.$router.push({
            path: "/shop/component/category",
            query: { id: id, catType: 1 },
          });
        } else {
          this.$router.push({
            path: "/shop/component/category",
            query: { catType: 1 },
          });
        }
      }
    },
    /**
     * [pageNavigateToShopComponentIndexAdd description] 服务推荐 - 删除
     * @return {[type]} [description]
     */
    handleShopComponentIndexDelete: function (row) {
      this.operateLoading = true;

      let params = {
        id: row.id,
      };

      shopComponentServiceDelete(params)
        .then((res) => {
          this.operateLoading = false;

          let { code, data, msg } = res;

          if (code == 0) {
            this.getList();
          } else {
            this.$message.error(msg);
          }
        })
        .catch((error) => {
          this.operateLoading = false;
          this.$message.error("服务器异常");
        });
    },
  },
  mounted() {
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
@import "../../../common/styles/base/mixin-font";
@import "../../../common/styles/base/mixin-common";

.filter-region.switch-center {
  height: 68px;

  span {
    font-size: 12px;
    color: $textColor;
    margin-right: 50px;
  }
}

.thumb-wrap {
  position: relative;
  display: inline-block;
  margin-right: 10px;
  vertical-align: middle;
  width: 96px;
  height: 48px;
  background-color: $colorPageBg;

  &.icon-wrap {
    width: 48px;
  }

  img {
    max-width: 100%;
    max-height: 100%;
    @include position(absolute, 1, 50%, none, none, 50%);
    @include translate(-50%, -50%, 0);
  }
}

.tips-color {
  color: $tipsColor;
}

.cursor-hand {
  cursor: pointer;
}

.express-title {
  padding: 0 5px;
  font-size: $smallFS;

  .express-item {
    padding: 0 5px;
    color: $textColor;
  }

  .express-info {
    /*width: 280px;*/
  }
}
</style>
